export default {
  sm: `
  데이터센터 각에서 이루어지는 데이터의 저장, 관리,
  활용은 모두 ‘친환경 기술' 안에서 이루어집니다. 
  에너지를 절약하고 이산화탄소 배출량을 줄여
  지속 가능한 미래를 만들겠습니다.
  `,
  xxl: `
  데이터센터 각에서 이루어지는 데이터의 저장, 관리, 활용은
  모두 ‘친환경 기술' 안에서 이루어집니다. 에너지를 절약하고
  이산화탄소 배출량을 줄여 지속 가능한 미래를 만들겠습니다.
  `
};
